// extracted by mini-css-extract-plugin
module.exports = {"layout":"AppLayout__layout--3DyTd","container":"AppLayout__container--3df5h"};